import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';

const AppOfflinePage = () => (
  <div className="dccf-app-shell flex items-center justify-center bg-[#001028] text-white min-h-[100dvh] px-6 text-center">
    <div className="max-w-sm">
      <div className="w-16 h-16 rounded-2xl bg-white/10 mx-auto mb-5 flex items-center justify-center">
        <WifiOff className="w-7 h-7 text-amber-300" />
      </div>
      <h1 className="text-[22px] font-bold tracking-tight mb-2">You're offline</h1>
      <p className="text-[13.5px] text-white/65 leading-relaxed mb-6">
        DCCF Network needs an internet connection to keep your community feed and messages in sync.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-[#E63946] hover:bg-[#c02a35] text-white text-[13px] font-bold transition-colors"
      >
        <RefreshCw className="w-4 h-4" /> Try again
      </button>
    </div>
  </div>
);

export default AppOfflinePage;
